import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "lp-page lp-item course-lesson" }
const _hoisted_2 = {
  key: 2,
  class: "lp-card course-lesson__denied"
}
const _hoisted_3 = { class: "course-lesson__denied-icon" }
const _hoisted_4 = {
  class: "lp-breadcrumb",
  "aria-label": "breadcrumb"
}
const _hoisted_5 = { class: "lp-breadcrumb__current" }
const _hoisted_6 = { class: "lp-item__grid" }
const _hoisted_7 = { class: "lp-item__stage" }
const _hoisted_8 = { class: "lp-video" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "lp-video__locked"
}
const _hoisted_11 = { class: "lp-video__lock" }
const _hoisted_12 = { class: "lp-item__head" }
const _hoisted_13 = { class: "lp-item__kicker" }
const _hoisted_14 = { class: "lp-item__type" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "lp-item__dot" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "course-lesson__links"
}
const _hoisted_17 = { class: "lp-item__actions" }
const _hoisted_18 = ["disabled", "aria-busy"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_20 = {
  class: "lp-tabs__list",
  role: "tablist"
}
const _hoisted_21 = ["aria-selected", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "lp-tabs__count"
}
const _hoisted_23 = {
  key: 0,
  class: "lp-tabs__panel"
}
const _hoisted_24 = {
  key: 1,
  class: "lp-tabs__empty"
}
const _hoisted_25 = {
  key: 1,
  class: "lp-tabs__panel"
}
const _hoisted_26 = {
  key: 0,
  class: "lp-tabs__description"
}
const _hoisted_27 = {
  key: 1,
  class: "lp-tabs__tags"
}
const _hoisted_28 = {
  key: 2,
  class: "lp-tabs__panel"
}
const _hoisted_29 = {
  key: 0,
  class: "lp-tabs__empty"
}
const _hoisted_30 = {
  key: 2,
  class: "lp-tabs__empty"
}
const _hoisted_31 = {
  key: 1,
  class: "lp-card course-lesson__loading"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "course-lesson__aside" }
const _hoisted_35 = {
  key: 4,
  class: "course-lesson__spinner"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)

import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { hasFeature } from "@/core/helpers/feature";
import CourseAchievementModal from "@/components/achivements/Course.vue";
import ModuleAchievementModal from "@/components/achivements/Module.vue";
import HcIcon from "@/modern/components/ui/HcIcon.vue";
import AttachmentList from "@/modern/components/training/learningPaths/item/AttachmentList.vue";
import { IAttachmentItem, lessonMaterialItems } from "@/modern/components/training/learningPaths/item/labs";
import ModuleContextBar from "@/modern/components/training/courses/lesson/ModuleContextBar.vue";
import ModulePlaylist from "@/modern/components/training/courses/lesson/ModulePlaylist.vue";
import LessonLabCard from "@/modern/components/training/courses/lesson/LessonLabCard.vue";
import LessonDiscussion from "@/modern/components/training/courses/lesson/LessonDiscussion.vue";
import LessonPager from "@/modern/components/training/courses/lesson/LessonPager.vue";
import RecommendedMachines from "@/modern/components/training/courses/lesson/RecommendedMachines.vue";
import { useCourseI18n } from "@/modern/components/training/courses/course";
import "@/modern/styles/lp.scss";

type Tab = "discussion" | "about" | "materials";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    lesson_id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string
  lesson_id?: string
}



const store = useStore();
const route = useRoute();
const router = useRouter();
const { t, lang, tc } = useCourseI18n();

const achivementModal = ref<InstanceType<typeof CourseAchievementModal> | null>(null);
const moduleAchievementModal = ref<InstanceType<typeof ModuleAchievementModal> | null>(null);
const tabsRef = ref<HTMLElement | null>(null);

const user = computed(() => store.getters.currentUser);
const module = computed(() => store.getters.getCurrentModule);
const moduleAccessDenied = computed(() => store.getters.getModuleAccessDenied);
const lesson = computed(() => store.getters.getLessonData);

const loaded = ref(false);
const selectedLessonId = ref<number | null>(null);
const courseModules = ref<any[]>([]);
const machines = ref<any[]>([]);
const tab = ref<Tab>("discussion");
const toggling = ref(false);

const lessons = computed<any[]>(() => module.value?.lessons || []);
const lessonIndex = computed(() => lessons.value.findIndex(item => item.id === selectedLessonId.value));
const lessonsDone = computed(() => lessons.value.filter(item => item.is_started).length);
const ready = computed(() => Boolean(lesson.value?.id) && lesson.value.id === selectedLessonId.value);
const canWatch = computed(() => hasFeature(module.value?.feature) || Boolean(module.value?.is_freemium));

const courseRoute = computed(() => ({ name: "training-module-list", params: { id: module.value?.course?.id } }));
const moduleIndex = computed(() => courseModules.value.findIndex(item => item.id === module.value?.id));
const moduleNumber = computed(() => moduleIndex.value >= 0 ? moduleIndex.value + 1 : null);
const prevModule = computed(() => moduleIndex.value > 0 ? courseModules.value[moduleIndex.value - 1] : null);
const nextModule = computed(() =>
  moduleIndex.value >= 0 && moduleIndex.value < courseModules.value.length - 1 ? courseModules.value[moduleIndex.value + 1] : null
);

const lessonRoute = (item: any) => ({ name: "training-module-show-lesson", params: { id: props.id, lesson_id: item.id } });
const moduleRoute = (item: any) => ({ name: "training-module-show", params: { id: item.id } });

const prev = computed(() => {
  const previous = lessons.value[lessonIndex.value - 1];
  if (lessonIndex.value > 0 && previous) {
    return { label: t(`${lang.value}.module.previous_lesson`), title: previous.title, to: lessonRoute(previous) };
  }
  if (prevModule.value) {
    return { label: tc("previous_module"), title: prevModule.value.title, to: moduleRoute(prevModule.value) };
  }
  return null;
});

const next = computed(() => {
  const following = lessons.value[lessonIndex.value + 1];
  if (lessonIndex.value >= 0 && following) {
    return { label: t(`${lang.value}.module.next_lesson`), title: following.title, to: lessonRoute(following) };
  }
  if (nextModule.value) {
    return { label: t(`${lang.value}.module.next_module`), title: nextModule.value.title, to: moduleRoute(nextModule.value) };
  }
  if (module.value?.course?.id) {
    return { label: tc("course_end"), title: t(`${lang.value}.common.back_to_course`), to: courseRoute.value };
  }
  return null;
});

// Marca d'água do Gumlet com o usuário, como na tela antiga
const videoSrc = computed(() => {
  const source = lesson.value?.video_url || "";
  if (!source.includes("gumlet.io")) return source;
  return `${source}&watermark_text=${user.value?.nick || "No nick"} - ${user.value?.email}`;
});

const lessonChallenge = computed(() => lesson.value?.challenges?.[0] || null);
const tags = computed<string[]>(() => (lesson.value?.tags || []).map((tag: any) => tag?.name ?? tag).filter(Boolean));
const materials = computed<IAttachmentItem[]>(() => lessonMaterialItems(lesson.value, tc("external_link"), lang.value));
const commentsCount = computed(() => lesson.value?.hacktivities?.length || 0);

const commentsLabel = computed(() => commentsCount.value === 1 ? tc("one_comment") : tc("comments_count", { n: commentsCount.value }));
const materialsLabel = computed(() => materials.value.length === 1 ? tc("one_material") : tc("materials_count", { n: materials.value.length }));

const tabs = computed(() => [
  { key: "discussion" as Tab, label: tc("discussion"), count: canWatch.value ? commentsCount.value : null },
  { key: "about" as Tab, label: tc("about_lesson"), count: null },
  { key: "materials" as Tab, label: tc("materials"), count: canWatch.value ? materials.value.length : null },
]);

const openTab = async (key: Tab) => {
  tab.value = key;
  await nextTick();
  tabsRef.value?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const fetchMachines = async (lessonId: number) => {
  try {
    const { data } = await ApiService.get(`academy/lessons/${lessonId}/recommended_machine`);
    machines.value = data.data || [];
  } catch (error) {
    machines.value = [];
  }
};

const fetchCourseModules = async (courseId?: number) => {
  if (!courseId) return;
  try {
    const { data } = await ApiService.get(`/academy/courses/${courseId}`);
    courseModules.value = data.data?.modules || [];
  } catch (error) {
    courseModules.value = [];
  }
};

const loadLesson = async (lessonId: number | null) => {
  if (!lessonId) return;
  selectedLessonId.value = lessonId;
  tab.value = "discussion";
  fetchMachines(lessonId);
  await store.dispatch(Actions.GET_LESSON, lessonId);
};

const pickInitialLesson = (): number | null => {
  const requested = Number(props.lesson_id || route.query.lesson);
  if (requested) return requested;
  const unwatched = lessons.value.find(item => !item.is_started);
  return (unwatched || lessons.value[0])?.id ?? null;
};

const loadModule = async () => {
  loaded.value = false;
  try {
    await store.dispatch(Actions.GET_MODULE, props.id);
    if (moduleAccessDenied.value) return;
    if (typeof module.value?.id === "undefined") {
      router.push("/");
      return;
    }

    await loadLesson(pickInitialLesson());
    fetchCourseModules(module.value.course?.id);

    const course = module.value.course;
    if (course?.status === "completed" && course.achievement && !course.achievement.is_read) {
      achivementModal.value?.openModal();
    }
  } catch (error) {
    console.error("[ModuleShow] Error getting the module:", error);
  } finally {
    loaded.value = true;
  }
};

const refreshLesson = () => {
  if (selectedLessonId.value) store.dispatch(Actions.GET_LESSON, selectedLessonId.value);
};

// Recarrega o módulo em segundo plano (status das aulas) e abre a conquista do módulo se acabou de ser liberada
const refreshModule = async () => {
  await store.dispatch(Actions.GET_MODULE, props.id);
  const current = module.value;
  if (current?.course?.status !== "completed" && current?.achievement && !current.achievement.is_read) {
    moduleAchievementModal.value?.openModal();
  }
};

// Botão fica desabilitado enquanto a requisição roda, para não desmarcar com um segundo clique
const toggleWatched = async () => {
  if (toggling.value || !selectedLessonId.value) return;
  toggling.value = true;
  try {
    await store.dispatch(Actions.UPDATE_WATCHED_CHECK, { id: selectedLessonId.value });
    await store.dispatch(Actions.GET_LESSON, selectedLessonId.value);
    await refreshModule();
  } catch (error) {
    console.error("Error checking the lesson:", error);
  } finally {
    toggling.value = false;
  }
};

const refreshAfterFlag = async () => {
  refreshLesson();
  await refreshModule();
};

const explode = () => {
  moduleAchievementModal.value?.openModal();
};

onMounted(loadModule);

watch(() => props.id, (value, old) => {
  if (value !== old) loadModule();
});

watch(() => props.lesson_id, (value) => {
  const lessonId = Number(value);
  if (loaded.value && lessonId && lessonId !== selectedLessonId.value) loadLesson(lessonId);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(module)?.course && _unref(module).course.has_achievement == true)
      ? (_openBlock(), _createBlock(CourseAchievementModal, {
          key: 0,
          ref_key: "achivementModal",
          ref: achivementModal,
          course: _unref(module)?.course
        }, null, 8, ["course"]))
      : _createCommentVNode("", true),
    (_unref(module) && _unref(module)?.course && _unref(module).course.has_achievement == true)
      ? (_openBlock(), _createBlock(ModuleAchievementModal, {
          key: 1,
          ref_key: "moduleAchievementModal",
          ref: moduleAchievementModal,
          module: _unref(module)
        }, null, 8, ["module"]))
      : _createCommentVNode("", true),
    (_unref(moduleAccessDenied) && loaded.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(HcIcon, {
              name: "lock",
              size: 26
            })
          ]),
          _createElementVNode("h2", null, _toDisplayString(_unref(t)(`${_unref(lang)}.module.unlock_your_full_potential`)), 1),
          _createVNode(_component_router_link, {
            to: { name: 'profile-billing' },
            class: "lp-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)(`${_unref(lang)}.common.subscribe`)) + " ", 1),
              _createVNode(HcIcon, {
                name: "arrow",
                size: 16
              })
            ]),
            _: 1
          })
        ]))
      : (loaded.value && _unref(module)?.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("nav", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "lp-breadcrumb__home"
              }, {
                default: _withCtx(() => [
                  _createVNode(HcIcon, {
                    name: "home",
                    size: 16
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: { name: 'course-catalog' } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(tc)('breadcrumb_root')), 1)
                ]),
                _: 1
              }),
              (_unref(module).course)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(HcIcon, {
                      name: "chevron-right",
                      size: 12,
                      class: "lp-breadcrumb__sep"
                    }),
                    _createVNode(_component_router_link, { to: _unref(courseRoute) }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(module).course.name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(ready))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(HcIcon, {
                      name: "chevron-right",
                      size: 12,
                      class: "lp-breadcrumb__sep"
                    }),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(lesson).title), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode(ModuleContextBar, {
              module: _unref(module),
              "module-number": _unref(moduleNumber),
              "modules-total": courseModules.value.length,
              "lessons-done": _unref(lessonsDone),
              "lessons-total": _unref(lessons).length,
              onShare: explode
            }, null, 8, ["module", "module-number", "modules-total", "lessons-done", "lessons-total"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_unref(ready))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_8, [
                        (_unref(canWatch))
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 0,
                              src: _unref(videoSrc),
                              frameborder: "0",
                              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                              allowfullscreen: ""
                            }, null, 8, _hoisted_9))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, [
                                _createVNode(HcIcon, {
                                  name: "lock",
                                  size: 26
                                })
                              ]),
                              _createElementVNode("p", null, _toDisplayString(_unref(t)(`${_unref(lang)}.module.unlock_your_full_potential`)), 1),
                              _createVNode(_component_router_link, {
                                to: { name: 'profile-billing' },
                                class: "lp-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)(`${_unref(lang)}.common.subscribe`)) + " ", 1),
                                  _createVNode(HcIcon, {
                                    name: "arrow",
                                    size: 16
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, [
                              _createVNode(HcIcon, {
                                name: "video",
                                size: 14
                              }),
                              _createTextVNode(_toDisplayString(_unref(tc)('lesson_type')), 1)
                            ]),
                            _hoisted_15,
                            _createElementVNode("span", null, _toDisplayString(_unref(tc)('lesson_position', { module: _unref(moduleNumber) || 1, index: _unref(lessonIndex) + 1, total: _unref(lessons).length })), 1)
                          ]),
                          _createElementVNode("h1", null, _toDisplayString(_unref(lesson).title), 1),
                          (_unref(canWatch))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openTab('discussion')))
                                }, [
                                  _createVNode(HcIcon, {
                                    name: "chat",
                                    size: 15
                                  }),
                                  _createTextVNode(_toDisplayString(_unref(commentsLabel)), 1)
                                ]),
                                (_unref(materials).length)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (openTab('materials')))
                                    }, [
                                      _createVNode(HcIcon, {
                                        name: "file",
                                        size: 15
                                      }),
                                      _createTextVNode(_toDisplayString(_unref(materialsLabel)), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["lp-btn", _unref(lesson).is_started ? 'lp-btn--success' : 'lp-btn--outline']),
                            disabled: !_unref(canWatch) || toggling.value,
                            "aria-busy": toggling.value,
                            onClick: toggleWatched
                          }, [
                            (toggling.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                              : (_openBlock(), _createBlock(HcIcon, {
                                  key: 1,
                                  name: "check",
                                  size: 16
                                })),
                            _createTextVNode(" " + _toDisplayString(_unref(lesson).is_started ? _unref(t)(`${_unref(lang)}.module.watched_lesson`) : _unref(t)(`${_unref(lang)}.module.mark_as_watched`)), 1)
                          ], 10, _hoisted_18),
                          (_unref(next))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: _unref(next).to,
                                class: "lp-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(next).label) + " ", 1),
                                  _createVNode(HcIcon, {
                                    name: "arrow",
                                    size: 16
                                  })
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_unref(canWatch) && _unref(lessonChallenge))
                        ? (_openBlock(), _createBlock(LessonLabCard, {
                            key: 0,
                            challenge: _unref(lessonChallenge),
                            onFlagAccepted: refreshAfterFlag
                          }, null, 8, ["challenge"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("section", {
                        ref_key: "tabsRef",
                        ref: tabsRef,
                        class: "lp-card lp-tabs"
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (item) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: item.key,
                              type: "button",
                              role: "tab",
                              "aria-selected": tab.value === item.key,
                              class: _normalizeClass(["lp-tabs__tab", { 'lp-tabs__tab--active': tab.value === item.key }]),
                              onClick: ($event: any) => (tab.value = item.key)
                            }, [
                              _createTextVNode(_toDisplayString(item.label) + " ", 1),
                              (item.count !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.count), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_21))
                          }), 128))
                        ]),
                        (tab.value === 'discussion')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_unref(canWatch))
                                ? (_openBlock(), _createBlock(LessonDiscussion, {
                                    key: 0,
                                    "lesson-id": _unref(lesson).id,
                                    hacktivities: _unref(lesson).hacktivities || [],
                                    onChanged: refreshLesson
                                  }, null, 8, ["lesson-id", "hacktivities"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                    _createVNode(HcIcon, {
                                      name: "lock",
                                      size: 16
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(lang)}.machine.available_only_for_members`)), 1)
                                  ]))
                            ]))
                          : (tab.value === 'about')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (_unref(lesson).description)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_unref(lesson).description), 1))
                                  : _createCommentVNode("", true),
                                (_unref(tags).length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (tag) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: tag,
                                          class: "lp-tag lp-tag--purple"
                                        }, _toDisplayString(tag), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (!_unref(canWatch))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                                      _createVNode(HcIcon, {
                                        name: "lock",
                                        size: 16
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(lang)}.machine.available_only_for_members`)), 1)
                                    ]))
                                  : (_unref(materials).length)
                                    ? (_openBlock(), _createBlock(AttachmentList, {
                                        key: 1,
                                        items: _unref(materials)
                                      }, null, 8, ["items"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_unref(tc)('no_materials')), 1))
                              ]))
                      ], 512),
                      _createVNode(LessonPager, {
                        prev: _unref(prev),
                        next: _unref(next)
                      }, null, 8, ["prev", "next"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(ModulePlaylist, {
                  module: _unref(module),
                  "module-number": _unref(moduleNumber),
                  "modules-total": courseModules.value.length,
                  "current-lesson-id": selectedLessonId.value,
                  locked: !_unref(canWatch),
                  "next-module": _unref(nextModule)
                }, null, 8, ["module", "module-number", "modules-total", "current-lesson-id", "locked", "next-module"]),
                _createVNode(RecommendedMachines, { machines: machines.value }, null, 8, ["machines"])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
    (!loaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("span", null, "Hacking " + _toDisplayString(_unref(t)(`${_unref(lang)}.common.loading`)) + "...", 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})